import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import DownloadIconPrimary from '../../assets/icons/DownloadIconPrimary';
import DownloadPdfIcon from '../../assets/icons/DownloadPdf';
import { useGetCertificatePdfDownloadUrl } from '../../hooks/api/certificates';
import styles from './DownloadCertificateButton.module.css';

type DownloadCertificateButtonProps = {
  certificateId?: number;
  pdfPath?: string;
};

const DownloadCertificateButton = ({
  certificateId,
  pdfPath,
}: DownloadCertificateButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const { refetch: fetchPDFDownloadUrl } = useGetCertificatePdfDownloadUrl(certificateId);

  const handleClick = async () => {
    if (!certificateId) {
      return;
    }

    const { data, isSuccess } = await fetchPDFDownloadUrl();
    if (isSuccess && data.downloadUrl) {
      window.open(data.downloadUrl, '_blank');

      return;
    }
  };

  return (
    <div className={`${styles['download-certificate-button']} flex flex-row align-items-center`}>
      <DownloadPdfIcon />
      <Button
        text
        disabled={!pdfPath}
        label={t('certificateDetailsPage.tabs.detailsTab.buttons.downloadPdf')}
        className='bg-transparent flex flex-row-reverse gap-1 text-black-alpha-90 p-1'
        icon={DownloadIconPrimary}
        onClick={handleClick}
      />
    </div>
  );
};

export default DownloadCertificateButton;
